
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import DecorationFloatingPoleLong from "../../decorations/shipwreck/DecorationFloatingPoleLong";
import PlatformMarkerLog from "../../editor/platform-markers/shipwreck/PlatformMarkerLog";
import PlatformMarkerLogKnot from "../../editor/platform-markers/shipwreck/PlatformMarkerLogKnot";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class TestChunkPlatformCollision extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 384);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, 422, 267);
    this.add(editor_bounds_left);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 3686, 267);
    this.add(editor_bounds_right);

    // pole_long_float_png
    const pole_long_float_png = new DecorationFloatingPoleLong(scene, 466, 140);
    this.add(pole_long_float_png);

    // pole_long_float_png_2
    const pole_long_float_png_2 = new DecorationFloatingPoleLong(scene, 1327, 145);
    this.add(pole_long_float_png_2);

    // pole_long_float_png_3
    const pole_long_float_png_3 = new DecorationFloatingPoleLong(scene, 1656, 145);
    this.add(pole_long_float_png_3);

    // pole_long_float_png_4
    const pole_long_float_png_4 = new DecorationFloatingPoleLong(scene, 2187, 149);
    this.add(pole_long_float_png_4);

    // pole_long_float_png_6
    const pole_long_float_png_6 = new DecorationFloatingPoleLong(scene, 3047, 155);
    this.add(pole_long_float_png_6);

    // pole_long_float_png_7
    const pole_long_float_png_7 = new DecorationFloatingPoleLong(scene, 3376, 155);
    this.add(pole_long_float_png_7);

    // pole_long_float_png_5
    const pole_long_float_png_5 = new DecorationFloatingPoleLong(scene, 2516, 149);
    this.add(pole_long_float_png_5);

    // pole_long_float_png_1
    const pole_long_float_png_1 = new DecorationFloatingPoleLong(scene, 795, 140);
    this.add(pole_long_float_png_1);

    // platformLog_3
    const platformLog_3 = new PlatformMarkerLog(scene, 3225, 9);
    this.add(platformLog_3);

    // platformLogKnot_2
    const platformLogKnot_2 = new PlatformMarkerLogKnot(scene, 2795, 7);
    this.add(platformLogKnot_2);

    // platformLog_1
    const platformLog_1 = new PlatformMarkerLog(scene, 2365, 3);
    this.add(platformLog_1);

    // platformLogKnot
    const platformLogKnot = new PlatformMarkerLogKnot(scene, 1935, 1);
    this.add(platformLogKnot);

    // platformLog
    const platformLog = new PlatformMarkerLog(scene, 1505, -1);
    this.add(platformLog);

    // platformLogKnot_1
    const platformLogKnot_1 = new PlatformMarkerLogKnot(scene, 1075, -3);
    this.add(platformLogKnot_1);

    // platformLog_4
    const platformLog_4 = new PlatformMarkerLog(scene, 644, -6);
    this.add(platformLog_4);

    // platformLog_5
    const platformLog_5 = new PlatformMarkerLog(scene, 638, -202);
    this.add(platformLog_5);

    // platformLogKnot_3
    const platformLogKnot_3 = new PlatformMarkerLogKnot(scene, 1069, -199);
    this.add(platformLogKnot_3);

    // platformLog_6
    const platformLog_6 = new PlatformMarkerLog(scene, 1499, -197);
    this.add(platformLog_6);

    // platformLogKnot_4
    const platformLogKnot_4 = new PlatformMarkerLogKnot(scene, 1929, -195);
    this.add(platformLogKnot_4);

    // platformLog_7
    const platformLog_7 = new PlatformMarkerLog(scene, 2359, -193);
    this.add(platformLog_7);

    // platformLogKnot_5
    const platformLogKnot_5 = new PlatformMarkerLogKnot(scene, 2789, -189);
    this.add(platformLogKnot_5);

    // platformLog_8
    const platformLog_8 = new PlatformMarkerLog(scene, 3219, -187);
    this.add(platformLog_8);

    // platformLog_2
    const platformLog_2 = new PlatformMarkerLog(scene, 3224, -449);
    this.add(platformLog_2);

    // platformLogKnot_6
    const platformLogKnot_6 = new PlatformMarkerLogKnot(scene, 2794, -451);
    this.add(platformLogKnot_6);

    // platformLog_9
    const platformLog_9 = new PlatformMarkerLog(scene, 2364, -455);
    this.add(platformLog_9);

    // platformLogKnot_7
    const platformLogKnot_7 = new PlatformMarkerLogKnot(scene, 1934, -457);
    this.add(platformLogKnot_7);

    // platformLog_10
    const platformLog_10 = new PlatformMarkerLog(scene, 1504, -459);
    this.add(platformLog_10);

    // platformLogKnot_8
    const platformLogKnot_8 = new PlatformMarkerLogKnot(scene, 1074, -461);
    this.add(platformLogKnot_8);

    // platformLog_11
    const platformLog_11 = new PlatformMarkerLog(scene, 643, -464);
    this.add(platformLog_11);

    // platformLog_12
    const platformLog_12 = new PlatformMarkerLog(scene, 3216, -808);
    this.add(platformLog_12);

    // platformLogKnot_9
    const platformLogKnot_9 = new PlatformMarkerLogKnot(scene, 2786, -810);
    this.add(platformLogKnot_9);

    // platformLog_13
    const platformLog_13 = new PlatformMarkerLog(scene, 2356, -814);
    this.add(platformLog_13);

    // platformLogKnot_10
    const platformLogKnot_10 = new PlatformMarkerLogKnot(scene, 1926, -816);
    this.add(platformLogKnot_10);

    // platformLog_14
    const platformLog_14 = new PlatformMarkerLog(scene, 1496, -818);
    this.add(platformLog_14);

    // platformLogKnot_11
    const platformLogKnot_11 = new PlatformMarkerLogKnot(scene, 1066, -820);
    this.add(platformLogKnot_11);

    // platformLog_15
    const platformLog_15 = new PlatformMarkerLog(scene, 635, -823);
    this.add(platformLog_15);

    // this (components)
    const thisChunkBoundaries = new ChunkBoundaries(this);
    thisChunkBoundaries.leftBoundsMarker = editor_bounds_left;
    thisChunkBoundaries.rightBoundsMarker = editor_bounds_right;
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
